export enum MWInstallmentsEnum {
  // Error messages
  // Generic messages
  // Success messages
  DisableMWInstallmentsFail = 'Nie udało się wyłączyć rat Mubi',
  DisableRequestExpired1 = 'Link wygasł. Skontaktuj się z naszym działem obsługi klienta.',
  InvalidToken = 'Nieprawidłowy token',
  MWInstallmentsAlreadyDisabled1 = 'Ups, raty Mubi zostały już wcześniej wyłączone.',
  MWInstallmentsAlreadyDisabled2 = 'Każde wyłączenie można potwierdzić tylko raz',
  MWInstallmentsDisabledSuccess = 'Raty Mubi zostały pomyślnie wyłączone',
}
